export default "__VITE_ASSET__C$cfBe7m__"